import { SelectOption } from '@web-for-marketing/react-ui';

const brazilianStateOptions: SelectOption[] = [
    { value: 'AC', content: 'Acre' },
    { value: 'AL', content: 'Alagoas' },
    { value: 'AP', content: 'Amapá' },
    { value: 'AM', content: 'Amazonas' },
    { value: 'BA', content: 'Bahia' },
    { value: 'CE', content: 'Ceará' },
    { value: 'DF', content: 'Distrito Federal' },
    { value: 'ES', content: 'Espírito Santo' },
    { value: 'GO', content: 'Goiás' },
    { value: 'MA', content: 'Maranhão' },
    { value: 'MT', content: 'Mato Grosso' },
    { value: 'MS', content: 'Mato Grosso do Sul' },
    { value: 'MG', content: 'Minas Gerais' },
    { value: 'PA', content: 'Pará' },
    { value: 'PB', content: 'Paraíba' },
    { value: 'PR', content: 'Paraná' },
    { value: 'PE', content: 'Pernambuco' },
    { value: 'PI', content: 'Piauí' },
    { value: 'RJ', content: 'Rio de Janeiro' },
    { value: 'RN', content: 'Rio Grande do Norte' },
    { value: 'RS', content: 'Rio Grande do Sul' },
    { value: 'RO', content: 'Rondônia' },
    { value: 'RR', content: 'Roraima' },
    { value: 'SC', content: 'Santa Catarina' },
    { value: 'SP', content: 'São Paulo' },
    { value: 'SE', content: 'Sergipe' },
    { value: 'TO', content: 'Tocantins' },
];

export default brazilianStateOptions;
